<ui-modal modalTitle="Manage Subscription">

	<ui-alert *ngIf="isInArrears" color="danger" icon="wq wq-warning" [dismissable]="false">You have an overdue balance on your account. Please settle it before changing your package.</ui-alert>

	<ng-container *ngIf="!isInArrears">
		<p class="text-large text-bold">Select a package below to upgrade your WeQuote account.</p>
		<div *ngIf="!selectedPackage?.is_downgrade">
			<i class="wq wq-check text-success mr-1"></i> You will instantly receive the benefits of your new subscription.
		</div>
		<div *ngIf="selectedPackage?.is_downgrade">
			<i class="wq wq-check text-success mr-1"></i> <span class="text-danger">You will keep your current benefits until your next billing date.</span>
		</div>
		<div>
			<i class="wq wq-check text-success mr-1"></i> Your new monthly premium will be applied from your next bill.
		</div>
	</ng-container>

	<div *ngIf="!isInArrears" class="my-3">
		<button *ngFor="let p of data?.packages" class="btn text-left h-auto w-100 my-2" [ngClass]="{ 'btn-light': selectedPackage !== p, 'btn-primary': selectedPackage === p && !p.is_downgrade, 'btn-danger': selectedPackage === p && p.is_downgrade }" (click)="selectedPackage = p">
			<span *ngIf="p.is_current" class="badge float-right" [ngClass]="{ 'badge-primary': selectedPackage !== p, 'badge-light': selectedPackage === p }">Current Package</span>
			<span *ngIf="p.is_downgrade" class="badge float-right" [ngClass]="{ 'badge-danger': selectedPackage !== p, 'badge-light': selectedPackage === p }">Downgrade</span>
			<div class="text-uppercase">{{p.name}}</div>
			<div><span class="h2">{{p.line_price | currency:'GBP'}}</span> <span *ngIf="p.cycle > 0" class="text-no-transform ml-1" [ngClass]="{ 'text-secondary': selectedPackage !== p }">/ {{p.cycle > 1 ? p.cycle : ''}} {{p.cycle_type + (p.cycle > 1 ? 's' : '')}}</span></div>
			<div *ngIf="p.value_quota" class="mt-2">
				<div class="text-no-transform">Up to {{p.value_quota | currencyDashboard:'GBP'}} per month in accepted quotes</div>
				<div class="text-no-transform" [ngClass]="{ 'text-secondary': selectedPackage !== p }">Quota rolls over monthly up to {{p.value_quota_rollover | currencyDashboard:'GBP'}}</div>
				<div *ngIf="p.max_quote_value > 0" class="text-no-transform" [ngClass]="{ 'text-secondary': selectedPackage !== p }">{{p.max_quote_value | currencyDashboard:'GBP'}} maximum quote value</div>
			</div>
			<div *ngIf="!p.value_quota" class="mt-2">
				<div class="text-no-transform">Unlimited accepted quotes</div>
			</div>
		</button>
	</div>

	<p *ngIf="!isInArrears && data?.packages.length === 1" class="text-large text-bold">You're already on the largest package available.</p>

	<p class="text-secondary"><i>If you need any help or would like to discuss your package, please contact us.</i></p>

	<p *ngIf="canRequestCancellation && !showCancellationForm" class="text-secondary mb-0">
		<button class="btn btn-link text-danger text-no-transform p-0" (click)="showCancellationForm = true" [disabled]="disabled">Request account cancellation</button>
	</p>

	<div *ngIf="canRequestCancellation && showCancellationForm" class="border-top pt-3">
		<p class="text-bold">Tell us why you'd like to cancel. Our team will be in touch to confirm.</p>
		<div class="form-group">
			<label>Reason <span class="text-primary">*</span></label>
			<select class="form-control" [(ngModel)]="cancellationReason" [ngModelOptions]="{ standalone: true }" [disabled]="disabled">
				<option value="" disabled>Choose a reason</option>
				<option *ngFor="let r of cancellationReasons" [value]="r">{{r}}</option>
			</select>
		</div>
		<div class="form-group">
			<label>Comments</label>
			<textarea class="form-control" rows="3" maxlength="5000" [(ngModel)]="cancellationFeedback" [ngModelOptions]="{ standalone: true }" [disabled]="disabled" placeholder="Anything else you'd like us to know"></textarea>
		</div>
		<div class="text-right">
			<button class="btn btn-medium mr-2" (click)="showCancellationForm = false" [disabled]="disabled">Back</button>
			<button class="btn btn-danger" (click)="requestCancellation()" [disabled]="disabled || !cancellationReason">Request Cancellation</button>
		</div>
	</div>

	<div class="text-small text-secondary" ui-modal-footer>All prices exclude {{app.translatedVATTerm}}.</div>
	<div class="flex-weight-1" ui-modal-footer></div>
	<button *ngIf="canCancelAccount" class="btn btn-purple mr-2" (click)="cancelAccount()" [disabled]="disabled" ui-modal-footer>Cancel Account</button>
	<button *ngIf="canResumeAccount" class="btn btn-purple mr-2" (click)="resumeAccount()" [disabled]="disabled" ui-modal-footer>Keep Subscription</button>
	<button class="btn btn-medium" (click)="modal.close()" [disabled]="disabled" ui-modal-footer>Close</button>
	<button *ngIf="!isInArrears && selectedPackage && selectedPackage !== currentPackage" class="btn {{selectedPackage?.is_downgrade ? 'btn-danger' : 'btn-primary'}}" (click)="upgradeButton()" [disabled]="disabled" ui-modal-footer>{{selectedPackage?.is_downgrade ? 'Downgrade' : 'Upgrade'}} to {{selectedPackage.name}}</button>
	<button *ngIf="!isInArrears && selectedPackage && selectedPackage === currentPackage && data?.has_next_package" class="btn btn-primary" (click)="upgradeButton()" [disabled]="disabled" ui-modal-footer>Keep current package</button>

</ui-modal>
